<template>
    <form @submit.prevent>
        <div class="o-filter-options o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap">
            <div class="flex-grid__item--third">
                <div class="flex-grid__item--third-label">Claim Type</div>
                <select v-model="claimType">
                    <option :value="null">All</option>
                    <option value="fatal_accident">All Fatal Accident</option>
                    <option value="fatal_accident_dependency">Fatal Accident Dependency</option>
                    <option value="fatal_accident_estate">Fatal Accident Estate</option>
                    <option value="lost_years">Lost Years</option>
                    <option value="personal_injury" v-if="diseaseOrAccident !== 'disease'">Personal Injury</option>
                </select>
            </div>

            <div class="flex-grid__item--third" v-if="claimType !== 'personal_injury'">
                <div class="flex-grid__item--third-label">Disease or Accident</div>
                <select v-model="diseaseOrAccident">
                    <option :value="null">All</option>
                    <option value="disease">Disease</option>
                    <option value="accident">Accident</option>
                </select>
            </div>

            <div class="flex-grid__item--third" v-if="diseaseOrAccident === 'disease'">
                <div class="flex-grid__item--third-label">Disease Type</div>
                <select v-model="diseaseType">
                    <option :value="null">All</option>
                    <option value="Asbestos Related Lung Cancer">Asbestos Related Lung Cancer</option>
                    <option value="Bladder Cancer">Bladder Cancer</option>
                    <option value="Kidney Cancer">Kidney Cancer</option>
                    <option value="Laryngeal Cancer">Laryngeal Cancer</option>
                    <option value="Leukemia">Leukemia</option>
                    <option value="Liver Cancer">Liver Cancer</option>
                    <option value="Mesothelioma">Mesothelioma</option>
                    <option value="Nasal Cancer">Nasal Cancer</option>
                    <option value="Other">Other</option>
                    <option value="Other Cancer">Other Cancer</option>
                    <option value="Skin Cancer">Skin Cancer</option>
                </select>
            </div>
            
            <div class="flex-grid__item--third" v-if="diseaseOrAccident === 'accident' || claimType === 'personal_injury'">
                <div class="flex-grid__item--third-label">Accident Type</div>
                <select v-model="accidentType">
                    <option :value="null">All</option>
                    <option value="Accident - EL">Accident - EL</option>
                    <option value="Accident - PL">Accident - PL</option>
                    <option value="Motor">Motor</option>
                    <option value="Other">Other</option>
                </select>
            </div>

            <div class="flex-grid__item--third">
                <div class="flex-grid__item--third-label">Discount Rate</div>
                <select name="discount_rate" id="discount_rate" v-model="discountRate">
                    <option :value="null">All</option>
                    <option :value="-2.0">-2.00%</option>
                    <option :value="-1.5">-1.50%</option>
                    <option :value="-1.0">-1.00%</option>
                    <option :value="-0.75">-0.75%</option>
                    <option :value="-0.5">-0.50%</option>
                    <option :value="-0.25">-0.25%</option>
                    <option :value="0.0">0.00%</option>
                    <option :value="0.5">0.50%</option>
                    <option :value="1.0">1.00%</option>
                    <option :value="1.5">1.50%</option>
                    <option :value="2.0">2.00%</option>
                    <option :value="2.5">2.50%</option>
                    <option :value="3.0">3.00%</option>
                </select>
            </div>

            <div class="flex-grid__item--third">
                <from-to></from-to>
            </div>
        </div>

        <button class="a-button a-button--small p-compare-reserve__top-form-button" @click="calculate">Load Claims</button>
    </form>
</template>

<script>
    import Control from 'components/form/Control';
    import {mapActions} from 'vuex';
    import FromTo from "./FromTo";

    export default {
        name: 'compare-form',
        components: {
            FromTo,
            Control
        },
        computed: {
            claimType: {
                get() {
                    return this.getValue('claimType');
                },
                set(value) {
                    this.diseaseOrAccident = null;
                    this.update({key: 'claimType', value})
                }
            },
            diseaseOrAccident: {
                get() {
                    return this.getValue('diseaseOrAccident');
                },
                set(value) {
                    this.diseaseType = null;
                    this.acceleration = null;

                    switch (true) {
                        case this.claimType === 'personal_injury':
                            value = 'accident';
                            break;
                        case (!['accident', 'disease'].includes(value)):
                            value = null;
                            break;
                    }

                    this.update({key: 'diseaseOrAccident', value});
                }
            },
            diseaseType: {
                get() {
                    return this.getValue('diseaseType');
                },
                set(value) {
                    // reset accident type to empty string
                    this.resetType({key: 'accidentType'});

                    // update disease type to value
                    value = this.diseaseOrAccident === 'disease' ? value : null;
                    this.update({key: 'diseaseType', value});
                }
            },
            accidentType: {
                get() {
                    return this.getValue('accidentType');
                },
                set(value) {
                    // reset disease type to empty string
                    this.resetType({key: 'diseaseType'});

                    // update accident type to value
                    value = this.diseaseOrAccident === 'accident' ? value : null;
                    this.update({key: 'accidentType', value});
                }
            },
            discountRate: {
                get() {
                    return this.getValue('discountRate');
                },
                set(value) {
                    this.update({key: 'discountRate', value})
                }
            }
        },
        methods: {
            ...mapActions('reserves/compare', ['update', 'calculate', 'resetType']),
            getValue(key) {
                return this.$store.getters['reserves/compare/' + key];
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Form.vue?6ab3b962